module.exports = __webpack_public_path__ + "img/QORO_BLADE.aa769513.jpg";